module.exports = __webpack_public_path__ + "static/media/StoreListingScreen.732b804e.png";